import { Injectable, inject } from '@angular/core';
import { HttpHandler, HttpRequest } from '@angular/common/http';
import { UserService } from '../services/user.service';

@Injectable()
export class OrganizationInterceptor {
  private userService = inject(UserService);


  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    const organizationId = this.userService.organizationId.value;
    // In case of Auth0 request, do not add organizationId header - it is not allowed
    if (!organizationId || request.url.includes('auth0.com')) {
      return next.handle(request);
    }
    request = request.clone({
      headers: request.headers.set(
        'X-Organization',
        this.userService.organizationId.value.toString(),
      ),
    });
    return next.handle(request);
  }
}
